module.exports = __webpack_public_path__ + "9760af16fc17ceaeb9ab4e88d6cdcd9f.jpg";